import { SvgBack } from '@/assets/icon';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface HeaderProps {
    activeTab: 'Volume' | 'Daily Streak';
    onTabChange: (tab: 'Volume' | 'Daily Streak') => void;
}

const TradingChallengeHeader: React.FC<HeaderProps> = ({
    activeTab,
    onTabChange,
}) => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    return (
        <header className="pt-4 pb-4 bg-black px-4">
            <div className="flex justify-between items-center mb-6">
                <button type="button" onClick={() => navigate('/earn')}>
                    <SvgBack />
                </button>
                <h1 className="text-white text-lg font-bold">
                    {t('Rewards Hub')}
                </h1>
                <div className="w-6" />
            </div>

            <div className="flex p-1 bg-[#1c1c1e] rounded-full mx-2">
                {['Volume', 'Daily Streak'].map((tab) => {
                    const isActive = activeTab === tab;

                    return (
                        <button
                            key={tab}
                            type="button"
                            onClick={() =>
                                onTabChange(tab as 'Volume' | 'Daily Streak')
                            }
                            className={clsx(
                                'flex-1 py-2 text-sm rounded-full transition-all duration-300',
                                {
                                    'bg-white text-black font-bold shadow-sm':
                                        isActive,
                                    'bg-transparent text-[#999] font-medium hover:text-gray-300':
                                        !isActive,
                                }
                            )}
                        >
                            {t(tab)}
                        </button>
                    );
                })}
            </div>
        </header>
    );
};

export default TradingChallengeHeader;
